import { render, staticRenderFns } from "./PrivacyPage.vue?vue&type=template&id=0b2d62c2"
import script from "./PrivacyPage.vue?vue&type=script&lang=js"
export * from "./PrivacyPage.vue?vue&type=script&lang=js"
import style0 from "./PrivacyPage.vue?vue&type=style&index=0&id=0b2d62c2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports